import Alert from "antd/es/alert"
import Button from "antd/es/button"
import { Link, useNavigate } from "react-router"

import { useActiveUserAuthorizationFromContext } from "../contexts/ActiveUserAuthorizationContext"
import "./SubscriptionExpiredBanner.css"

const SubscriptionExpiredBanner: React.FC = () => {
  const navigate = useNavigate()
  const { isDisabled } = useActiveUserAuthorizationFromContext()

  if (!isDisabled) {
    return null
  }
  return (
    <Alert
      className="free-trial-banner fixed bottom-0 h-[20vh] w-full text-center"
      closable={true}
      message={
        <div>
          Your free trial has expired. Please{" "}
          <Link className="text-purple-500" to="/group/settings/billing/plans">
            upgrade
          </Link>{" "}
          to continue using Quilt
          <Button
            className="ml-[10px]"
            type="primary"
            onClick={() => navigate("/group/settings/billing/plans")}
          >
            Upgrade Plan
          </Button>
        </div>
      }
      type="warning"
      showIcon
      banner
    />
  )
}
export default SubscriptionExpiredBanner
